import React, { useEffect } from 'react'
import imgMeasurement from '../../assets/news-events/Measurement.png'
import ImageDescription from '../../Components/ImageDescription/ImageDescription'
import TextCaption from '../../Components/TextCaption/TextCaption'
import SectionHeader from '../../Components/SectionHeader/SectionHeader'
import imgMeasurement_01 from '../../assets/news-events/Measurement_01.png'
import imgMeasurement_02 from '../../assets/news-events/Measurement_02.png'
import imgMeasurement_03 from '../../assets/news-events/Measurement_03.png'
import CenterStage from '../../Components/CenterStage/CenterStage'


const Measurement = () => {

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

    return (
        <div>
            <div>
                <CenterStage
                    imageSrc={imgMeasurement}
                    title={"Essential Tools for Hydraulic Measurement"}
                    paragraph={[
                        "Anyone who has ever had to identify a hydraulic connection in their day-to-day life knows that you can't just rely on your eyes. A wrong measurement or a hasty identification can cause rework, delays and even greater losses if the wrong part is installed. And remember, often the difference between one connection and another is minimal — but it makes all the difference in the system."
                    ]}
                />
            </div>

            {/* <TextCaption
                paragraph="Text: Gabriela Nascimento and Tatiana Schrader May 28, 2025."
            /> */}

            <TextCaption
                paragraph="That's why having the right tools on hand is the first step to avoiding headaches and saving time. At HANSA-FLEX, we believe that knowledge and preparation are just as important as the equipment. If you work with hoses, fittings, adapters or hydraulic systems in general, stay with us and we'll show you how to put together a basic and efficient kit to measure and identify parts safely and quickly."
            />


            <TextCaption
                title="Caliper: your best friend on the bench"
                paragraph="If there's one tool you can't do without, it's the caliper. It's responsible for accurately measuring external and internal diameters, and even the depth of parts. In other words, it's the caliper that will tell you whether a connection is 15, 16, or 17 mm in diameter — because it's almost impossible to tell by eye."
            />

            <TextCaption
                paragraph="There are several models: analog, digital, with a clock... but the most practical for everyday use is the digital one, especially for beginners. The reading is direct, fast and avoids confusion. At HANSA-FLEX, we use calipers with a minimum resolution of 0.05 mm, which guarantees greater precision. With this, you already take an important step towards identifying the right part and avoiding errors when replacing it."
            />

            <ImageDescription
                imageSrc={imgMeasurement_01}
                title={"Twist Comb: the secret is in the step"}
                paragraphs={[
                    "The thread gauge may seem simple, but it is one of the smartest tools in your tool kit. It helps you find the thread pitch — that is, the distance between the threads. This may seem like a small detail, but it is this “detail” that determines whether the part is BSP, metric, JIC, NPT, among others."
                    , "The comb has two sides: one for metric threads (with measurements such as 1.25 or 1.5 mm) and the other for inches, with threads per inch (14, 16, 18 threads, for example). The idea is to fit the teeth of the comb into the thread of the piece until you find the one that fits perfectly. With the pitch identified, it is much easier to continue with the measurement and confirm the correct pattern."
                ]}
            />

            <TextCaption
                paragraph="And the best part: together with the caliper, the thread comb forms an unbeatable duo when it comes to safely identifying connections."
            />

            <TextCaption
                title="Thread Chart: a handy guide"
                paragraph="After measuring the diameter and thread pitch, it’s time to compare everything with a thread chart. This chart lists the main standards used in the hydraulic industry, with measurements, thread types and applications. It’s like a map that helps you cross-reference the information you’ve just collected with the options available on the market."
            />

            <TextCaption
                paragraph="Here at HANSA-FLEX, we have our own table, based on the most common threads we encounter in everyday life. This greatly helps to speed up identification and provides greater security for those working in the field or in the workshop."
            />

            {/* {button to add} */}
            <TextCaption
                title='“Important Information” Guide: Our Ace Up Our Sleeve'
                paragraph="This is one of our backstage secrets. The “Important Information” material was created by our technical team to make life much easier for those who are trying to figure out what a particular piece is."
            />


            <TextCaption
                paragraph="Start with simple but fundamental questions: is the part male or female? Does it have an O-ring? Does it have a sealing cone or a flat face? Is it straight or curved? Based on this, check the most likely codes. And look, in practice, this saves a lot of time."
            />

            <TextCaption
                paragraph="For example:"
                bulletPoints={[
                    "Did you see a 24° cone and an O-ring on the female? There's a good chance it's a DIN connection (codes like AOL or HL ).",
                    "60° or 74° cone? Can be a JIC or BSP ( AJ , HJ , AB , HB ).",
                    "Flat face with Oring? Bet on an ORFS ( AJF , HJOF )."
                ]}
            />

            <TextCaption
                paragraph="This material also provides tips for differentiating between conical and parallel threads, by looking at the finish of the part and the shape of the seal. It organizes the identification process by probability and prevents you from making the mistake of relying solely on appearance."
            />
            {/* {button to add} */}
            <br /><br />
            <ImageDescription
                imageSrc={imgMeasurement_02}
            />

            <TextCaption
                title='Paper and Pen: the classic that never fails'
                paragraph="It may seem obvious, but writing down the measurements you take is a habit that avoids rework and confusion. Especially when you serve many clients or work with different types of systems."
            />

            <TextCaption

                paragraph="Always have a notebook or technical sheet at hand and record:"
                bulletPoints={[
                    "Spike diameter",
                    "Thread inner diameter",
                    "Pitch or number of threads per inch",
                    "Probable part code"
                ]}
            />

            <TextCaption
                paragraph="Over time, this becomes a knowledge base that helps you become more agile and assertive. In addition, organized notes help when consulting old parts, placing orders and even training new colleagues."
            />

            <br /><br />
            <ImageDescription
                imageSrc={imgMeasurement_03}
                title='Being a technician is also being an observer'
                paragraph="More than knowing how to use the tools, a good professional learns to look carefully. Starting with the appearance of the part, using the logic of the most likely codes and only then measuring accurately is what makes all the difference in the field."
            />

            <TextCaption
                paragraph="At HANSA-FLEX, we believe that technique and method go hand in hand. That’s why we invest in training, share exclusive materials such as “What could it be?” and encourage the use of the right tools from the first consultation. The result? Fewer errors, more confidence and excellent technical service."
            />

            <TextCaption
                paragraph="If you want to stand out in the hydraulics field, you don’t need to reinvent the wheel. Start with the basics — and do it well. Having a good caliper, a reliable thread comb, an up-to-date chart and a technical eye will put you one step ahead."
            />

            <TextCaption
                title="Want to dig even deeper?"
                paragraph="At HANSA-FLEX, we believe that technical knowledge is what turns professionals into experts. If you want to learn in practice how to identify connections, use measuring tools correctly and have all your questions answered by experts, our training courses are for you."
            />

            <TextCaption
                paragraph="Get in touch with our team and find out how to participate in HANSA-FLEX technical training."
            />

            <TextCaption
                paragraph="Just reach out on WhatsApp, call or send an email — we’ll help you take the next step!"
            />
            <br /><br />
        </div>

    )
}

export default Measurement